import styled from 'styled-components'

const Paragraph = styled.p`
  margin-top: 0;
  margin-bottom: 32px;
  padding-right: 32px;
`

export default Paragraph
